import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import alertSnackbarActions from '../store/actions/alertSnackbarActions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const AlertSnackbar = (props) => {
  const {
    alertSnackbar, setOpen, setSeverity, setMessage
  } = props;
  const { open, severity, message } = alertSnackbar;
  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
    setSeverity('error');
    setMessage('');
  };

  return (
    <div className={classes.root}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert severity={severity} onClose={handleClose}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

AlertSnackbar.propTypes = {
  alertSnackbar: PropTypes.object,
  setOpen: PropTypes.func,
  setSeverity: PropTypes.func,
  setMessage: PropTypes.func,
};

const mapStateToProps = (state /* , ownProps */) => {
  return {
    alertSnackbar: state.alertSnackbar
  };
};

const { setOpen, setMessage, setSeverity } = alertSnackbarActions;

const mapDispatchToProps = { setOpen, setMessage, setSeverity };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertSnackbar);
